// Tolerância de dias para associar colheita a ciclo — a PRIMITIVA, compartilhada.
//
// Morava só em `server/lib/tolerancia.ts`. Mudou de casa quando o diálogo de
// fechar ciclo passou a precisar da mesma conta (o aviso "fecha sozinho em …"),
// pelo mesmo motivo de `shared/data-fazenda.ts`: duas cópias da mesma constante
// é como as divergências entre tela e servidor nascem. O servidor continua
// importando de `server/lib/tolerancia.ts`, que reexporta daqui.
//
// O parâmetro `TOLERANCIA_DIAS_COLHEITA` é OPCIONAL: org nova não precisa
// "inicializar" nada — na ausência (ou com valor inválido) vale o default.

export const TOLERANCIA_DIAS_COLHEITA = "TOLERANCIA_DIAS_COLHEITA";
export const TOLERANCIA_DIAS_COLHEITA_DEFAULT = 15;

/**
 * Valor cru do parâmetro → dias. Ausente, não-numérico ou < 1 caem no default.
 *
 * 🔴 Devolve NÚMERO. O valor vem do banco como string ("35"): quem fizer
 * `param?.valor || 15` fica com uma string e todo `+ tolerancia` vira
 * concatenação.
 */
export function normalizarToleranciaDias(valor: string | null | undefined): number {
  const n = valor != null ? parseInt(valor, 10) : NaN;
  return Number.isFinite(n) && n >= 1 ? n : TOLERANCIA_DIAS_COLHEITA_DEFAULT;
}
